import React, { useState, useEffect, useRef } from "react";
import ImageZoom from "../../../../components/common/ImageZoom";
import { Carousel, Button } from "antd";
import "./index.scss";
import { useTranslation } from "react-i18next";

function TechnicalPositions() {
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");
  const technicalPositionsContent = t("residency.space_part5", {
    returnObjects: true,
  });
  return (
    <div className="technical_">
      <div className="technical_introduce">
        <div className="technical_int_con">
          <div className="technical_int_title">
            {technicalPositionsContent.introduceTitle}
          </div>
          <div className="technical_int_content">
            {technicalPositionsContent.introduceContent}
          </div>
        </div>
      </div>
      <div className="edition_solution">
        <div className="edition_solution_title">
          <div>{technicalPositionsContent.first.title}</div>
          <div className="technical_title_undlineBox">
            <span className="technical_title_undline"></span>
          </div>
          <span>{technicalPositionsContent.first.describe}</span>
        </div>
      </div>
      <div className="technical_con">
        {technicalPositionsContent.first.list.map((item, index) => {
          return (
            <div
              key={index}
              className="technical_li"
              style={
                language === "zh" ? { height: "240px" } : { height: "340px" }
              }
            >
              <div className="technical_li_img"></div>
              <div className="technical_li_text">
                <div
                  className="technical_li_til"
                  style={
                    language === "zh"
                      ? { fontSize: "24px" }
                      : { fontSize: "18px" }
                  }
                >
                  {item.itemTitle}
                </div>
                <div
                  className="technical_li_con"
                  style={
                    language === "zh"
                      ? { fontSize: "16px" }
                      : { fontSize: "14px" }
                  }
                >
                  {item.itemContent}
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="edition_solution">
        <div className="edition_solution_title">
          <div>{technicalPositionsContent.second.title}</div>
          <div className="technical_title_undlineBox">
            <span className="technical_title_undline"></span>
          </div>
          <span>{technicalPositionsContent.second.describe}</span>
        </div>
      </div>
      <div className="technical_con2">
        {technicalPositionsContent.second.list.map((item, index) => {
          return (
            <div key={index} className="technical_li2">
              <div className="technical_li2_other">
                <div className="technical_li2_text">
                  <div className="technical_li2_til">{item.itemTitle}</div>
                  <div className="technical_li2_con">
                    {item.list.map((item2, index2) => {
                      return (
                        <div key={index2} className="technical_li2_con_item">
                          {item2}
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default TechnicalPositions;
